import React, { useState, useEffect, useCallback } from 'react'

const FuelCostCalc = () => {

   const [inputData, setInputData] = useState({
      distance: "500",
      distanceType: "kilometres",
      fuelEfficiency: "10",
      fuelEfficiencyType: "kilometresPerLitre",
      fuelCost: "3",
      fuelType: "perLitre",
   })

   const [resultData, setResultData] = useState({
      totalFuelCost: "150",
      distance: "500",
      requiredFuel: "50",
   })

   const calculateFuelCostAndQuantity = useCallback(() => {
      let distanceMultiplier = 1;
      let fuelEfficiencyMultiplier = 1;
      let fuelPriceMultiplier = 1;
      let fuelRequired = 0;

      switch (inputData.distanceType) {
         case 'kilometres':
            distanceMultiplier = 1;
            break;
         case 'miles':
            distanceMultiplier = 1.609344;
            break;
         default:
            break;
      }

      switch (inputData.fuelEfficiencyType) {
         case 'kilometresPerLitre':
            fuelEfficiencyMultiplier = 1;
            fuelRequired = (inputData.distance * distanceMultiplier) / inputData.fuelEfficiency
            // setResultData({...prev, requiredFuel:fuelRequired})
            break;
         case 'litresPer100km':
            fuelEfficiencyMultiplier = inputData.fuelEfficiency/100;
            fuelRequired = (inputData.distance * distanceMultiplier) * fuelEfficiencyMultiplier
            // setResultData({...prev, requiredFuel:fuelRequired})
            break;
         // case 'litresPerMile':
         //    fuelEfficiencyMultiplier = 0.264172052 * distanceMultiplier;
         //    fuelRequired = (inputData.distance * distanceMultiplier) / (fuelEfficiencyMultiplier * inputData.fuelEfficiency)
         //    break;
         case 'milesPerGallon':
            fuelEfficiencyMultiplier = 0.425143707;
            fuelRequired = (inputData.distance * distanceMultiplier) / (fuelEfficiencyMultiplier * inputData.fuelEfficiency)
            break;
         default:
            break;
      }

      switch (inputData.fuelPriceType) {
         case 'perLitre':
            fuelPriceMultiplier = 1;
            break;
         case 'perGallon':
            fuelPriceMultiplier = 3.78541178;
            break;
         default:
            break;
      }

      // const fuelRequired = (inputData.distance * distanceMultiplier) / (fuelEfficiencyMultiplier * inputData.fuelEfficiency);
      // setTotalFuelRequired(fuelRequired);
      // console.log(fuelRequired)

      const fuelCost = fuelRequired * inputData.fuelCost * fuelPriceMultiplier;
      // setTotalFuelCost(fuelCost);
      // console.log(fuelPriceMultiplier)
      // console.log(fuelRequired, " ", fuelCost)
      setResultData(prev => ({ ...prev, distance: inputData.distance, requiredFuel: fuelRequired, totalFuelCost: fuelCost }))
   }, [inputData]);

   useEffect(()=>{
      calculateFuelCostAndQuantity()
   }, [calculateFuelCostAndQuantity])

   return (
      <div className="w-full max-w-[1000px] bg-gray-100 mx-auto py-[30px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]">
         <div className="max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px] py-[30px] md:py-[30px]">
            <div className="flex flex-col">
               <div className="text-gray-500 flex flex-col gap-[10px]">
                  <h3 className="text-gray-700 font-medium text-[18px] border-b-2 pb-[15px] mb-[10px]">Fuel Cost By Distance Travelled</h3>
                  <div className="flex gap-[5px] flex-col justify-between items-start">
                     <h3 className="text-gray-500 font-medium text-[16px]">Trip Distance</h3>
                     <div className="flex flex-col md:flex-row items-start justify-center gap-[10px]">
                        <input
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={inputData.distance}
                           onChange={(e) => setInputData(prev => ({ ...prev, distance: e.target.value }))}
                        />
                        <select
                           className="border outline-none rounded-md w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           required
                           value={inputData.distanceType}
                           onChange={(e) => setInputData(prev => ({ ...prev, distanceType: e.target.value }))}
                        >
                           <option value="kilometres">kilometres</option>
                           <option value="miles">miles</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex gap-[5px] flex-col justify-between items-start">
                     <h3 className="text-gray-500 font-medium text-[16px]">Fuel Efficiency</h3>
                     <div className="flex flex-col md:flex-row items-start justify-center gap-[10px]">
                        <input
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={inputData.fuelEfficiency}
                           onChange={(e) => setInputData(prev => ({ ...prev, fuelEfficiency: e.target.value }))}
                        />
                        <select
                           className="border outline-none rounded-md w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           required
                           value={inputData.fuelEfficiencyType}
                           onChange={(e) => setInputData(prev => ({ ...prev, fuelEfficiencyType: e.target.value }))}
                        >
                           <option value="kilometresPerLitre">kilometers per liter (km/L)</option>
                           <option value="milesPerGallon">miles per gallon (mpg)</option>
                           {/* <option value="litresPerMile">liters per mile</option> */}
                           <option value="litresPer100km">liters per 100km (L/100 km)</option>
                        </select>
                     </div>
                  </div>
                  <div className="flex gap-[5px] flex-col justify-between items-start">
                     <h3 className="text-gray-500 font-medium text-[16px]">Gas/Fuel Price</h3>
                     <div className="flex flex-col md:flex-row items-start justify-center gap-[10px]">
                        <input
                           className="rounded-md border text-gray-500 outline-none py-2 px-3 w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           type="text"
                           placeholder=""
                           required
                           value={inputData.fuelCost}
                           onChange={(e) => setInputData(prev => ({ ...prev, fuelCost: e.target.value }))}
                        />
                        <select
                           className="border outline-none rounded-md w-full md:w-[50%] h-[50px]"
                           id=""
                           name=""
                           required
                           value={inputData.fuelType}
                           onChange={(e) => setInputData(prev => ({ ...prev, fuelType: e.target.value }))}
                        >
                           <option value="perLitre">per liter</option>
                           <option value="perGallon">per gallon</option>
                        </select>
                     </div>
                  </div>

                  <button onClick={() => calculateFuelCostAndQuantity()} className="w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl">Calculate</button>
               </div>
            </div>
         </div>
         <div className="w-[100%] lg:w-[50%] h-full flex flex-col gap-[20px]">
            <h3 className="text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500">Result</h3>
            <div className="flex flex-col justify-center items-center bg-gray-200 w-fit mx-auto p-[30px] rounded-full">
               <h1 className="text-[20px] font-medium text-gray-500">Total Fuel Cost</h1>
               <div className="text-[60px] font-bold text-gray-700">${parseFloat(resultData.totalFuelCost).toFixed(2)}</div>
            </div>
            <div className="w-full text-gray-500 font-medium flex flex-col gap-[10px]">
               <div className=" flex items-center gap-[30px] justify-around text-[20px] mx-[15px]">
                  <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">Units</div>
                  <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">Output</div>
               </div>
               <div className=" flex items-center justify-around text-[18px] text-gray-400">
                  <div className="w-[50%] text-center">Distance</div>
                  <div className="w-[50%] text-center">{inputData.distanceType==="kilometres"?resultData.distance+" Km":resultData.distance+" miles"}</div>
               </div>
               <div className=" flex items-center justify-around text-[18px] text-gray-400">
                  <div className="w-[50%] text-center">Fuels Required</div>
                  <div className="w-[50%] text-center">{inputData.fuelType==="perLitre"?parseFloat(resultData.requiredFuel).toFixed(2)+" Litres":parseFloat(resultData.requiredFuel).toFixed(2)+" Gallons"}</div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default FuelCostCalc
